/** 全局数据状态共享  https://nuxt.com/docs/getting-started/state-management */
import domain from '@/server-config/domain.config'

export const useHomeConfig: any = () => useState<any>('home_config', () => ([]) )
export const useImgLazy = () => useState<'loading' | 'loaded'>('img_lazy', () => process.client ? 'loading' : 'loaded')

export const useNewArrival: any = () => useState<any>('new_arrival', () => null )
export const HomeTagList: any = () => useState<any>('home_tag_list', () => null )
export const useRouterLoading: any = () => useState<boolean>('router-loading', () => true )
export const useRequestLoading: any = () => useState<boolean>('request-loading', () => false )
export const useImg1pxBase64 = () => useState<string>('img1px-base64', () => 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' )
export const OldWapUrl: any = () => useState<string>('old_wap_url', () => domain.OLD_WAP_URL )
export const IsWebp: any = () => useState<boolean>('is_webp', () => false )
export const useUserInfo: any = () => useState<any>('userInfo', () => useCookie('UserInfo').value)
export const useCategory = () => useState<ICategory[]>('categorys', () => ([]))
export const useWapCategory = () => useState<IHomeCategory[]>('categorys', () => ([]))
export const useRecommendCategory = () => useState<ICategory[]>('recommend-categories', () => ([]))
export const useCurrentCountry = () => useState<number | string>('countryId', () => useCookie('regionId').value || 6)
export const useCurrentCountryCode = () => useState<string>('countryCode', () => useCookie('regionCode').value || 'KE')
export const useCountrys = () => useState<region.IRegionItem[]>('countrys', () => [])
export const useShopingCartTotal = () => useState<number>('shoping_cart_total', () => 0)

export const useIsAndroid = () => useState<boolean>('is_android', () => false)
export const useIsSellerAndroid = () => useState<boolean>('is_seller_android', () => false)
export const useIsMobile = () => useState<boolean>('is_mobile', () => false)
export const useIsFlutterApp = () => useState<boolean>('is_flutter_app', () => false)

export const useShoppingCartLaconicList = () => useState<IShoppingCartLaconic[]>('shopping_cart_list', () => ([]))
export const isFacebook = () => useState<boolean>('is_facebook', () => false)
export const isWhatsApp = () => useState<boolean>('is_whatsapp', () => false)
export const isTiktok = () => useState<boolean>('is_tiktok', () => false)
// 1: pending ship; 2: in transit; 3: Pending Sign; 4: sign; -1: reject, -2: cancel
export const useCodPackageStateMap = () => useState<IAnyObject>('cod-package-state-map', () => ({
  1: 'Pending ship',
  2: 'In transit',
  3: 'Pending Sign',
  4: 'Sign',
  '-1': 'Cancel',
  '-2': 'Reject'
}))
// 1、表示未支付；2、表示支付成功；3、表示支付失败；4、表示用户取消支付；
export const useCodPaymentMap = () => useState<IAnyObject>('cod-payment-map', () => ({
  1: 'Unpaid',
  2: 'Paid',
  // 下面两项应该是没有的，先保留
  3: '支付失败',
  4: '用户取消支付'
}))

export const useFlashSalesStatusMap = () => useState<{ [key: string]: string }>('flash-sales-status', () => ({
  1: 'On Going',
  2: 'Coming Up',
  3: 'Coming Up',
  4: 'Over'
}))

export const usePersonalCount = () => useState<IPersonalCount>('personal-count')

export const useGiftsCatch = () => useState<IAnyObject>('gifts_catch', () => ({}))

export const useCookiePopupShow = () => useState<boolean>('cookie-popup-show', () => true)

export const useDashVideoJSLoadingState = () => useState<'loading' | 'loaded' | 'pending'>('dash-video-jsl-loading-state', () => 'pending')


export const useS3HomeMap = () => useState<any>('s3_home_map', () => null)

export const useGlobalJsonData = () => useState<IAnyObject>('global-json-data', () => ({}))
